import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isGaEnabled, sendPageView } from "../../analytics/gtag";

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isGaEnabled()) return;
    sendPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
